<template>

    <div  class="modal fade"
      id="exampleModalToggle"
      aria-hidden="true"
      aria-labelledby="exampleModalToggleLabel"
      tabindex="-1"
      :data-bs-backdrop="prizedraw?.length < 1 ? 'static' : true"
      :data-bs-keyboard="prizedraw?.length < 1 ? 'false' : true"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalToggleLabel">{{titleModal($_store.state.typeEventPrizeDrawClient.type, $_store.state.typeEventPrizeDrawClient.client) }}</h5>
              <button 
                type="button" 
                class="btn-close" 
                data-bs-dismiss="modal" 
                aria-label="Close"
                v-if="prizedraw?.length >= 1" ></button>
            </div>
            <div class="modal-body">
              <EditDeletePrizeDraw v-if="$_store.state.typeEventPrizeDrawClient.type === 'E' || $_store.state.typeEventPrizeDrawClient.type === 'D'"/>
              <PrizeDrawClientCreate v-if="$_store.state.typeEventPrizeDrawClient.type === 'A'"/>
              <CreateEditPrizeDraw v-if="$_store.state.typeEventPrizeDrawClient.type === 'PE'"/>
              <CreateEditPrizeDraw v-if="prizedraw?.length < 1 || $_store.state.typeEventPrizeDrawClient.type === 'PC'"/>
            </div>
          </div>
        </div>
    </div>
    
    <div class="container mt-5" >    
        <div class="card-header bg-transparent border-0 ms-2">
            <div>
                <img
                    src="../../assets/logo.png"
                    alt="Logomarca"
                    class="img-fluid mx-auto d-block mt-4"
                    width="120"
                />
            </div>
            <h4 class="text-center my-3">
              <font-awesome-icon icon="print" />
                Lista de Cliente para Sorteio
            </h4>
            <hr />
        </div>
        
        <div class="mt-5">
          <button
            class="btn btn-sm btn-outline-dark d-flex justify-content-end align-items-center ms-auto mb me-3"
            @click="opeBlockFilter"
            v-if="prizedrawClient?.length > 0"
          >
              <font-awesome-icon
              icon="arrow-up-wide-short"
              class="me-2"
              v-if="openFilter"
              />
              <font-awesome-icon icon="arrow-down-wide-short" class="me-2" v-else />
              Filtrar
          </button>
          <div class="row">
            <a
              class="custom-link mb-2 col-lg-2 col-md-4 col-sm-5"
              @click="setOpenAdd"
              data-bs-toggle="modal" 
              href="#exampleModalToggle" 
              role="button"
            >
              Cadastrar novo cliente
            </a>
          
            <a
              class="custom-link mb-2 col-lg-2 col-md-4 col-sm-5"
              @click="setOpenPrizeDraw"
              data-bs-toggle="modal"
              href="#exampleModalToggle"
              role="button"
            >
              Editar sorteio
            </a>
          
            <router-link 
              to="/prizedraw-start" 
              class="custom-link mb-2 col-lg-2 col-md-4 col-sm-5"
            >
              Ir para sorteio
            </router-link>

            <a
              v-if="prizedrawClient.length > 0 && !openDeleteAll"
              class="custom-link mb-2 col-lg-2 col-md-4 col-sm-5"
              @click="setOpenDeleteAll"
              role="button"
            >
              Remover todos clientes
            </a>

            <div 
              class="p-2 btn-primary mb-2 col-lg-2 col-md-4 col-sm-5"
              style="background-color: #f3f2f2;"
              v-if="prizedrawClient.length > 0 && openDeleteAll"
            >
              <div class="text-center">
                <a

                class="custom-link-delete text-primary mr-3"
                @click="deleteAllClients"
                role="button"
              >
                confirmar
              </a>

              <a
                class="custom-link-delete text-danger"
                @click="setOpenDeleteAll"
                role="button"
              >
                cancelar
              </a>
              </div>
              
           </div>
            <a
              id="create-prizedraw"
              class=""
              data-bs-toggle="modal" 
              href="#exampleModalToggle" 
              role="button"
              hidden
            >
            </a>
          </div>
          
        </div>  

        <LoadingObjet class="text-center" v-show="loadDelete || loadStart" />
        <div v-if="prizedrawClient?.length === 0 && !loadDelete && !loadStart" class="alert alert-light text-center" role="alert">
            <h5 class="custom-mt text-center mb-5" >
                <font-awesome-icon icon="circle-exclamation" />
                Atualmente, não há Cliente para o sorteio {{prizedraw?.name}}.
            </h5>
        </div>
        
        <!-- Filtros de pesquisa -->
          <div class="row mb-3 d-flex justify-content-end" v-if="openFilter && !loadDelete && !loadStart">
            <div class="col-md-3">
                <label for="filtroNomeMaterial" class="form-label filtros">Nome do cliente:</label>
                <input
                    id="filtroNomeMaterial"
                    class="form-control"
                    placeholder="Digite o nome do cliente"
                    v-model="nameClient"
                />
            </div>
            <!-- Adicione mais filtros aqui, se necessário -->
          </div>
  
          <table
               v-if="prizedrawClient?.length > 0 && !loadDelete && !loadStart"
              class="text-center table table-dark table-striped mb-5 custom-table"
          >
              <thead>
                  <tr>
                      <th>Nome do cliente</th>
                      <th>Sorteio</th>
                      <th>Qtd de Cupom</th>
                      <th>Data de Criação</th>
                      <th>Editar</th>
                      <th>Remover</th>
                  </tr>
              </thead>
              <tbody>
                  <!--  @click="viewMaterial(item.id) -->
                  <template v-for="item in ordeName(filteredPrizedrawClient)" :key="item.id">
                      <tr class="align-items-center">
                            <td>{{ item?.name }}</td>
                            <td>{{ prizedraw?.name }}</td>
                            <td>{{ item.coupon }}</td>
                            <td>{{ convertDate(item?.createdAt) }}</td>
                            <td class="clickable text-primary">
                                <font-awesome-icon 
                                    icon="pencil-alt"
                                    data-bs-toggle="modal" 
                                    href="#exampleModalToggle" 
                                    role="button"
                                    @click="setOpenEdit(item)"
                                />
                            </td>
                            <td class="clickable text-danger">
                                <font-awesome-icon 
                                    icon="trash-can" 
                                    data-bs-toggle="modal" 
                                    href="#exampleModalToggle" 
                                    role="button" 
                                    @click="setOpenRemove(item)"
                                />
                            </td>
                      </tr>
                  </template>
              </tbody>
          </table>
  
          <div>
              <h6 class="text-secondary custom-mt text-center"
                  v-if="!filteredPrizedrawClient.length && nameClient"
              >
                  Desculpe, não encontramos resultados correspondentes à sua pesquisa.
                  <br />
                  Tente usar termos diferentes ou ajustar os filtros para obter melhores resultados.
              </h6>
          </div>
    </div>
  </template>
  
  
<script>
  import { computed, onBeforeMount, ref } from 'vue';
  import store from "../../store";
  import { convertDate, ordeName } from "../../utils";
  import EditDeletePrizeDraw from './EditDeletePrizeDrawClient.vue';
  import PrizeDrawClientCreate from "./CreatePrizeDrawClient.vue";
  import CreateEditPrizeDraw from "./CreateEditPrazeDraw.vue";
  import { deletePrizedrawClient } from '@/http';
  import LoadingObjet from '@/components/LoadingObjet';
  export default {
    name: 'ListMaterial',
    setup(){
      const loadDelete = ref(false);
      const loadStart = ref(false);
      const openDeleteAll = ref(false);
      const prizedraw = computed(() => store.state.prizedraw || []);
      const prizedrawClient = computed(() => store.state.prizedrawClient);

      const nameClient = ref('');
  
      const filteredPrizedrawClient = computed(() => {
        const _nameClient = nameClient.value.toLowerCase();
  
        return prizedrawClient.value?.filter(
          (client) =>
            client.name?.toLowerCase().includes(_nameClient)
        );
      });

      const setOpenAdd = () => {
        store.commit('setTypeEventPrizeDrawClient', {type: 'A'});
      }

      const setOpenPrizeDraw = () => {
        store.commit('setTypeEventPrizeDrawClient', {type: 'PE'});
      }

      const setOpenRemove = (client) => {
        store.commit('setTypeEventPrizeDrawClient', {type: 'D', client: client});
      }

      const setOpenEdit = (client) => {
        store.commit('setTypeEventPrizeDrawClient', {type: 'E', client: client});
      }

      const openFilter = ref(false);
      const opeBlockFilter = () => {
        openFilter.value = openFilter.value ? false : true;
      };

      const deleteAllClients = async () => {
        loadDelete.value = true;
        for (const item of prizedrawClient.value) {
          if (item?.id) {
            try {
              await deletePrizedrawClient(item.id);
            } catch (error) {
              console.error('Erro ao deletar cliente:', error);
            }
          }
        }

        await store.dispatch('onGetPrizeDrawClient');
        loadDelete.value = false;
      };

      const setOpenDeleteAll = () => {
        openDeleteAll.value = openDeleteAll.value ? false : true;
      }


      const titleModal = (type, client) => {
        switch(type){
          case 'A':
            return 'Cadastrar Cliente para Sorteio';
          case 'E':
            return 'Editar Cliente ' + client.name;
          case 'D': 
            return 'Remover Cliente ' + client.name;
          case 'PE': 
            return 'Editar Sorteio';
          case 'PC': 
            return 'Criar Sorteio';
        }
      }
      onBeforeMount(async () =>{
        loadStart.value = true;
        await store.dispatch('onGetPrizeDraw');
        await store.dispatch('onGetPrizeDrawClient');
        
        if (prizedraw.value?.length < 1) {
          store.commit('setTypeEventPrizeDrawClient', { type: 'PC' });

          // Aguarde um pequeno tempo para garantir que o DOM está renderizado
          setTimeout(() => {
            const el = document.getElementById('create-prizedraw');
            if (el) el.click();
          }, 100); // 100ms costuma ser suficiente
        }
        loadStart.value = false;
      });
  
      return {
        ordeName,
        titleModal,
        setOpenAdd,
        setOpenRemove,
        setOpenEdit,
        opeBlockFilter,
        openFilter,
        filteredPrizedrawClient,
        convertDate,
        nameClient,
        prizedraw,
        prizedrawClient,
        setOpenPrizeDraw,
        deleteAllClients,
        loadDelete,
        loadStart,
        openDeleteAll,
        setOpenDeleteAll,
      }
    },
    components: {
        EditDeletePrizeDraw,
        PrizeDrawClientCreate,
        CreateEditPrizeDraw,
        LoadingObjet,
    }
  }
  </script>
  <style scoped>
  .custom-mt {
    margin-top: 70px;
  }
  
  .custom-table {
    border-radius: 10px;
    overflow: hidden;
    margin-bottom: 80px;
  }
  
  .barra-pesquisa {
    margin-top: 100px;
  }
  
  .filtros {
    font-family: Arial, Helvetica, sans-serif;
    font-weight: bold;
    font-size: 0.8rem;
  }

  .custom-link {
    cursor: pointer;
    font-size: 15px;
    color: gray;
    font-weight: bold;
    text-decoration: none; /* Remove sublinhado */
    transition: color 0.3s, background-color 0.3s; /* Transição de cor e fundo */
    text-align: center;
  }
  
  .custom-link-delete {
    cursor: pointer;
    font-size: 15px;
    color: rgb(248, 241, 241);
    font-weight: bold;
    text-decoration: none; /* Remove sublinhado */
    transition: color 0.3s, background-color 0.3s; /* Transição de cor e fundo */
    text-align: center;
    padding: 5px;
  }
  

  .custom-link:hover {
    color: #020202; 
    font-weight: bold;
    border-bottom: #020202 solid 2px; 
    border-radius: 8px;
  }
  
  .custom-link-delete:hover {
    color: #c2bfbf;
    font-weight: bold;
    border-bottom: #e9e0e0 solid 2px; 
    border-radius: 8px;
  }

  .clickable {
    cursor: pointer;
  }
  .clickable :hover {
    width: 23px;
    height: 23px;
    color: #fff;
  }
  </style>